import { RefreshCw } from "lucide-react";
import { fmtClock } from "@/lib/format";

// MT5 connection status pill. Auto-reflects backend sync state.
export default function MT5Status({ sync, compact = false }) {
  if (!sync) return null;
  const status = sync.mt5_status || "disconnected";
  const mode = sync.mode || "DEMO";

  const cfg = {
    connected: { color: "#10B981", label: "CONNECTED", dot: true },
    syncing: { color: "#D4AF37", label: "SYNCING", spin: true },
    disconnected: { color: "#EF4444", label: "DISCONNECTED", dot: true },
  }[status];

  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="mt5-status-badge">
      <div className="flex items-center gap-2 rounded-full border border-white/10 bg-[#0F0F12] px-3 py-1.5">
        {cfg.spin ? (
          <RefreshCw size={12} className="dlx-spin" style={{ color: cfg.color }} />
        ) : (
          <span className="dlx-dot-pulse h-2 w-2 rounded-full" style={{ background: cfg.color, color: cfg.color }} />
        )}
        <span className="font-sans text-[10px] font-semibold uppercase tracking-widest" style={{ color: cfg.color }}>
          {cfg.label}
        </span>
        {!compact && (
          <span className="hidden font-mono text-[10px] text-zinc-500 sm:inline">
            · {fmtClock(sync.last_sync)}
          </span>
        )}
      </div>
      <span
        className="rounded-full border px-2.5 py-1 font-mono text-[10px] font-semibold tracking-wider"
        style={{
          color: mode === "LIVE" ? "#10B981" : "#D4AF37",
          borderColor: mode === "LIVE" ? "rgba(16,185,129,.4)" : "rgba(212,175,55,.4)",
          background: mode === "LIVE" ? "rgba(16,185,129,.08)" : "rgba(212,175,55,.06)",
        }}
        data-testid="data-mode-badge"
      >
        {mode === "LIVE" ? "LIVE MT5 DATA" : "DEMO MODE"}
      </span>
    </div>
  );
}
